import { useEffect } from 'react'

const useHtmlTitle = (title) => {
  useEffect(() => {
    document.title = `Эффективный город${title ? ': ' : ''}${title}`
  }, [title])
}

export default useHtmlTitle
